
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/personuverndarstefna",
      function () {
        return require("private-next-pages/um/fyrirtaekid/personuverndarstefna.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/personuverndarstefna"])
      });
    }
  